import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { PagerComponent} from '../paginator/pager.component';
import { EstudoResumoComponent } from './estudo-resumo.component';
import { EstudoResumoButtonComponent } from './estudo-resumo-button.component';
import { EstudoResumoDialog } from './estudo-resumo.dialog';

/** AngularMaterial **/
import { MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatToolbarModule, MatProgressBarModule, MatSnackBarModule, MatTabsModule, MatCheckboxModule, MatDialogModule, MatListModule, MatCardModule } from '@angular/material';
import { EstudoDialogModule } from '../estudo-dialog/estudo-dialog.module';
import { ObservacaoEstudoModule } from '../observacao-estudo/observacao-estudo.module';


@NgModule({
    declarations: [
      EstudoResumoComponent, EstudoResumoDialog, EstudoResumoButtonComponent
    ],
    exports: [
      EstudoResumoComponent, EstudoResumoDialog, EstudoResumoButtonComponent
    ],
    imports: [
      FormsModule, CommonModule, EstudoDialogModule, ObservacaoEstudoModule,
      MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatProgressBarModule, MatSnackBarModule,  MatDialogModule, MatCardModule, MatListModule, MatToolbarModule, MatTabsModule
    ],
    providers: [
      PagerComponent
    ]
})
export class EstudoResumoModule {

}
